import { render, staticRenderFns } from "./CreateKasKecil.vue?vue&type=template&id=013c3ca0&scoped=true&"
import script from "./CreateKasKecil.vue?vue&type=script&lang=js&"
export * from "./CreateKasKecil.vue?vue&type=script&lang=js&"
import style0 from "./CreateKasKecil.vue?vue&type=style&index=0&id=013c3ca0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013c3ca0",
  null
  
)

export default component.exports